import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';

interface MessengerNotification {
  id: string;
  conversationId: string;
  userName: string;
  userProfilePic: string;
  message: string;
  timestamp: Date;
}

interface MessengerNotificationPopupProps {
  notification: MessengerNotification | null;
  onClose: () => void;
}

const MessengerNotificationPopup: React.FC<MessengerNotificationPopupProps> = ({ 
  notification, 
  onClose 
}) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (notification) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onClose, 300); // Attendre la fin de l'animation
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification, onClose]);

  if (!notification) return null;

  const handleClick = () => {
    navigate(`/social-media?tab=messaging&conversation=${notification.conversationId}`);
    onClose();
  };

  // Tronquer le message si trop long
  const truncateMessage = (text: string, maxLength: number = 50) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };

  return (
    <div
      className={`fixed top-4 right-4 z-50 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full'
      }`}
    >
      <div 
        onClick={handleClick}
        className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 cursor-pointer hover:shadow-xl transition-shadow max-w-sm"
      >
        <div className="flex items-start space-x-3">
          <img
            src={notification.userProfilePic || `https://ui-avatars.com/api/?name=${encodeURIComponent(notification.userName)}&background=0D8ABC&color=fff`}
            alt={notification.userName}
            className="w-12 h-12 rounded-full object-cover flex-shrink-0"
          />
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-900">
                  {notification.userName}
                </p>
                <p className="text-sm text-gray-600 mt-1">
                  {truncateMessage(notification.message)}
                </p>
                <p className="text-xs text-gray-400 mt-1">
                  Messenger • À l'instant
                </p>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onClose();
                }}
                className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors"
              >
                <X className="w-4 h-4 text-gray-400" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessengerNotificationPopup;
